// extracted by mini-css-extract-plugin
export default {"field":"Select_field__Zh7IU","label":"Select_label__qvjfw","select":"Select_select__rDXl1","error":"Select_error__AZZwt","errorText":"Select_errorText__E4Eg5"};